import BaseEntity from './BaseEntity'

const Props = {
  videoUrl: undefined,
  thumbnailUrl: undefined,
}

class Video extends BaseEntity {}

export default function createVideo(params) {
  const attr = Object.assign({}, Props, params)
  return Object.freeze(new Video(attr))
}
